import React from "react";
import "../../styles/booking-form.css";
import { Form, Row, Col } from "reactstrap";
import "../../styles/payment-method.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import {addFinalTripCost ,addFinalHour} from "../../Features/bookingSlice";
import { async } from "q";
import { useMemo } from "react";

const BookingForm = () => {
  // findCarDetails: null,
  // selectedCar:null

  const dispatch = useDispatch();
  const bookingSelector = useSelector((state) => state.booking);
  //const userSelector = useSelector((state) => state.user);

  const[timeDiff,setTimeDiff]=useState("")


   const timeObject =useMemo(()=>{ 
    return {
            hours : Math.floor(timeDiff/(1000*3600))*(-1),
            minutes : Math.floor((timeDiff%(1000*3600))/(1000*60))*(-1)
   }},[timeDiff])
   dispatch(addFinalHour(`${timeObject.hours}.${timeObject.minutes}`))



  useEffect(()=>{
   
    const func =()=>{
     const timeDifference = new Date(bookingSelector.findCarDetails.selectedDateForTripStart) - new Date(bookingSelector.findCarDetails.selectedDateForTripEnd);
     setTimeDiff(timeDifference);
    }
    func()
  },[])


  return (
    <Form style={{ backgroundColor: "#d9dde1" }} className="rounded">
      <Row >
        <Col className="mx-3" lg="4">
          <Row className="mb-3 payment">
            <label className=" fs-75">Total Trip Hours :</label>
          </Row>
          <Row className="mb-3 payment">
            <label className=" fs-75">Per Hour Cost :</label>
          </Row>
          <Row className="mb-3 payment">

            <label className=" fs-75">Total Trip Cost :</label>
          </Row>
          <Row className="mb-3 payment">
            <label className=" fs-75">GST Applied :</label>
          </Row>
        </Col>
        <Col>
          <Row className="mb-3 payment">
            <label className=" fs-75 ">{bookingSelector?.finalHour}Hr.</label>
          </Row>
          <Row className="mb-3 payment">
            <label className="fs-75 text-success">₹{bookingSelector.selectedCar?.baseFare}</label>
          </Row>
          <Row className="mb-3 payment">
            <label className=" fs-75 text-success">₹{bookingSelector?.finalTripCost}</label>
          </Row>
          <Row className="mb-3 payment">
            <label className=" fs-75">18%</label>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default BookingForm;
